import { render, staticRenderFns } from "./resourceAction.vue?vue&type=template&id=1107f5f8&scoped=true"
import script from "./resourceAction.vue?vue&type=script&lang=js"
export * from "./resourceAction.vue?vue&type=script&lang=js"
import style0 from "./resourceAction.vue?vue&type=style&index=0&id=1107f5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107f5f8",
  null
  
)

export default component.exports